export default __webpack_public_path__ + "static/media/known_vulberability.63d9f9ba.svg";